<template>
  <div>
    <IviewModal
      :value="value"
      :footer-hide="true"
      :styles="{ top: marginTop }"
      :mask-closable="maskClosable"
      :width="width"
      @on-cancel="oncancel"
      :z-index="zIndex"
    >
      <h1 slot="header" class="ts-font-robot ts-text-2xl">{{ title }}</h1>
      <button
        slot="close"
        class="ts-bg-red-700 ts-h-6 ts-w-6 ts-rounded-full ts-flex ts-items-center ts-justify-center ts-text-white ts-font-bold hover:ts-bg-gray-600 ts-transition-all ts-duration-200"
      >
        <i class="fas fa-times"></i>
      </button>
      <slot></slot>
    </IviewModal>
  </div>
</template>

<script>
import { Modal as IviewModal } from 'view-design'
export default {
  components: {
    IviewModal
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    value: {},
    title: {
      type: String,
      default: () => 'Tittle'
    },
    maskClosable: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: [Number, String],
      default: () => 520
    },
    marginTop: {
      type: [Number, String],
      default: () => '10vh'
    },
    zIndex: {
      type: [Number, String],
      default: () => 100
    }
  },
  data() {
    return {
      show_model: false
    }
  },
  created() {
    this.show_model = this.value
  },
  methods: {
    oncancel() {
      this.$emit('update', false)
    }
  }
}
</script>
